function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    d: "m12 16 1.4-1.4-1.6-1.6H16v-2h-4.2l1.6-1.6L12 8l-4 4zm0 6a9.732 9.732 0 0 1-3.9-.788A9.978 9.978 0 0 1 2.788 15.9 9.732 9.732 0 0 1 2 12a9.732 9.732 0 0 1 .788-3.9A9.984 9.984 0 0 1 8.1 2.787 9.743 9.743 0 0 1 12 2a9.743 9.743 0 0 1 3.9.787A9.984 9.984 0 0 1 21.212 8.1 9.732 9.732 0 0 1 22 12a9.732 9.732 0 0 1-.788 3.9 9.978 9.978 0 0 1-5.312 5.312A9.732 9.732 0 0 1 12 22z",
    style: {
      fill: "#21a2ee"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.dfcb472df63fc572cf003ca7990c1b1b.svg";
export { ForwardRef as ReactComponent };